import e from "axios";
//#region src/modules/file-uploader/utils/create-canceler.ts
var t = () => {
	let t;
	return {
		createToken: () => (t = e.CancelToken.source(), t.token),
		cancel: () => {
			t &&= (t.cancel(), void 0);
		},
		getToken: () => t?.token
	};
};
//#endregion
export { t as createCanceler };
